<rw-modal
  modalId="licenseAddEditModal"
  datapendoid="license-add-edit-modal"
  datatestid="license-add-edit-modal"
  [title]="actionText + ' License'"
  arialabel="{{ actionText }} License"
  [dismissible]="true"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div class="row ownerShipRow">
      <div class="form-group col-sm-12 ownerShipDivision">
        <label for="source">Ownership:&nbsp;</label>
        <span>BYOL</span>
      </div>
      <div>
        <form [formGroup]="licenseForm">
          <div class="row" #formTop>
            <div
              class="form-group col-sm-12"
              [ngClass]="{
                'has-error': licenseYear.invalid && hasSubmitted
              }"
            >
              <label for="year">Year</label>
              <rw-single-select
                id="yearSelect"
                [items]="yearsSelect"
                bindLabel="label"
                bindValue="value"
                arialabel="add license year select"
                datapendoid="addlicense-year-select"
                datatestid="addlicense-year-select"
                formControlName="licenseYear"
                (valueChanged)="versionChange()"
              >
              </rw-single-select>
              @if (licenseYear.invalid && hasSubmitted) {
                <div>
                  @if (licenseYear.hasError('required')) {
                    <div class="help-block">Required field</div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div
              class="form-group col-sm-12"
              [ngClass]="{
                'has-error': licenseEdition.invalid && hasSubmitted
              }"
            >
              <label for="edition">Edition</label>
              <rw-single-select
                id="editionSelect"
                [items]="editionsSelect"
                bindLabel="label"
                bindValue="value"
                arialabel="add license edition select"
                datapendoid="addlicense-edition-select"
                datatestid="addlicense-edition-select"
                [placeholder]="!licenseYear.value ? 'Please select a year before choosing an edition' : ''"
                [isReadOnly]="!licenseYear.value"
                formControlName="licenseEdition"
              >
              </rw-single-select>
              @if (licenseEdition.invalid && hasSubmitted) {
                <div>
                  @if (licenseEdition.hasError('required')) {
                    <div class="help-block">Required field</div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div
              class="form-group col-sm-9"
              [ngClass]="{
                'has-error': licenseCountry.invalid && (licenseCountry.dirty || licenseCountry.touched)
              }"
            >
              <label for="country">Country</label>
              <div class="p-formgroup-inline">
                <div class="p-field-checkbox">
                  <input
                    type="radio"
                    data-testid="countrySelectUS"
                    id="countrySelectUS"
                    value="US"
                    formControlName="licenseCountry"
                    (change)="countryChange()"
                  />
                  <label class="radio-label" for="countrySelectUS">US</label>
                </div>
                <div class="p-field-checkbox">
                  <input
                    type="radio"
                    data-testid="countrySelectCan"
                    id="countrySelectCan"
                    value="CA"
                    formControlName="licenseCountry"
                    (change)="countryChange()"
                  />
                  <label class="radio-label" for="countrySelectCan">Canada</label>
                </div>
              </div>
              @if (licenseCountry.invalid && (licenseCountry.dirty || licenseCountry.touched)) {
                <div>
                  @if (licenseCountry.hasError('required')) {
                    <div class="help-block">Required field</div>
                  }
                </div>
              }
            </div>
          </div>
          <div
            class="row"
            [ngClass]="{
              'has-error': licenseKey.invalid && hasSubmitted
            }"
          >
            <div class="form-group col-sm-12">
              <label for="licenseKeyEdit">License Key</label>
              <input
                data-testid="licenseKeyEdit"
                data-pendo-id="licenseKeyEdit"
                id="licenseKeyEdit"
                class="form-control"
                matInput
                [mask]="licenseKeyMask"
                [validation]="true"
                type="tel"
                placeholder="QuickBooks License Number"
                #licenseKeyText
                formControlName="licenseKey"
                (focus)="$event.target.select()"
              />
              @if (licenseKey.invalid) {
                <div>
                  @if (licenseKey.hasError('required') && hasSubmitted) {
                    <div class="help-block">Required field</div>
                  } @else if (licenseKey.hasError('mask')) {
                    <div class="help-block">Please enter a valid license key</div>
                  }
                </div>
              }
            </div>
          </div>
          <div
            class="row"
            [ngClass]="{
              'has-error': productNumber.invalid && hasSubmitted
            }"
          >
            <div class="form-group col-sm-12">
              <label for="productNumberEdit">Product Number</label>
              <input
                data-testid="productNumberEdit"
                data-pendo-id="productNumberEdit"
                id="productNumberEdit"
                matInput
                [mask]="productNumberMask"
                [validation]="true"
                type="tel"
                placeholder="QuickBooks Product Number"
                class="form-control"
                formControlName="productNumber"
                (focus)="$event.target.select()"
              />
              @if (productNumber.invalid) {
                <div>
                  @if (productNumber.hasError('required') && hasSubmitted) {
                    <div class="help-block">Required field</div>
                  } @else if (productNumber.hasError('mask')) {
                    <div class="help-block">Please enter a valid product number</div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-12">
              <rw-checkbox
                [id]="'isAutoAssignable'"
                [text]="'Automatically assign license to users when they install QuickBooks.'"
                [arialabel]="'check to automatically assign license to users when they install QuickBooks'"
                [datapendoid]="'isAutoAssignable'"
                [datatestid]="'isAutoAssignable'"
                [(isChecked)]="isAutoAssignable"
              ></rw-checkbox>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div modal-footer>
    <app-button
      data-testid="cancelBtn"
      id="cancelLink"
      label="CANCEL"
      buttonStyle="addUserTeritary"
      (clickActionEmitter)="close()"
    >
    </app-button>
    <app-button
      data-testid="saveBtn"
      id="submitBtn"
      label="SAVE"
      showProcessing="true"
      [processing]="processing"
      buttonStyle="primary"
      (clickActionEmitter)="validateAndSubmit()"
    >
    </app-button>
  </div>
</rw-modal>
